import { PublicClientApplication, InteractionRequiredAuthError, BrowserAuthError } from '@azure/msal-browser';

// Prevent multiple concurrent session-expired redirects
let sessionExpiredRedirecting = false;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENT_ID || '',
    authority: process.env.REACT_APP_SSO_Authorities || '',
    knownAuthorities: ['login.microsoftonline.com'],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
 
export const loginRequest = {
  scopes: ['api://b8cd7a5f-4d46-4718-96b3-c5f74ac587fc/access_as_user'],
};
 
export const msalInstance = new PublicClientApplication(msalConfig);
 
// Function to get an access token
export const getToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        account: accounts[0],
        scopes: loginRequest.scopes,
      });
      return response.accessToken;
    } catch (error) {
      console.error('Silent token acquisition failed, falling back to interactive login.', error);
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response = await msalInstance.acquireTokenPopup({
            scopes: loginRequest.scopes,
          });
          return response.accessToken;
        } catch (interactiveError) {
          console.error('Interactive token acquisition failed.', interactiveError);
          throw interactiveError;
        }
      } else if (
        error instanceof BrowserAuthError &&
        (error.errorCode === 'timed_out' || error.errorCode === 'login_required')
      ) {
        // Session expired — redirect to Microsoft login once
        if (!sessionExpiredRedirecting) {
          sessionExpiredRedirecting = true;
          sessionStorage.setItem('session_expired', 'true');
          await msalInstance.loginRedirect(loginRequest);
        }
        return null;
      } else {
        throw error;
      }
    }
  } else {
    console.error('No accounts found. User needs to sign in.');
    throw new Error('No accounts found.');
  }
};